<template>
    <CompetencesEmpty v-if="!getHardCompetences.length" competences-type="hard"/>
    <HardCompetences
        v-else
        :items="getHardCompetences"
        :variants="getCompetenceKnowledge"
    />
</template>

<script>
import HardCompetences from "./HardCompetences";
import CompetencesEmpty from "../CompetencesEmpty";
import { mapGetters } from 'vuex';

const trackGetters = [
    'getHardCompetences',
    'getCompetenceKnowledge',
];

export default {
    name: "HardCompetencesWrapper",

    components: {
        HardCompetences,
        CompetencesEmpty,
    },

    computed: {
        ...mapGetters('accountTrack', trackGetters),
    },
};
</script>

<style scoped>

</style>